// Dashboard chat's settings in a dialog, over the settings home or over the
// chat itself: the model, and the provider and key Origin uses for it, as two
// tabs. With no key yet it opens on the provider and key; `tab` ("model" or
// "provider") opens one by name. `onSaved` hears each save.
import { DIALOG } from "../../lib/analytics/surfaceVocabulary.js";
import OverlayDialog from "../OverlayDialog.jsx";
import ChatModelPicker from "../ChatModelPicker.jsx";

export default function ChatSettingsDialog({ open, tab = null, onClose, onSaved = null }) {
    return (
        <OverlayDialog open={open} onClose={onClose} analyticsId={DIALOG.CHAT_SETTINGS} title="Chat settings" width="580px" flush>
            <div className="flex max-h-[min(560px,68vh)] min-h-0 flex-col" data-chat-settings="">
                <ChatModelPicker tab={tab} onSaved={onSaved} />
            </div>
        </OverlayDialog>
    );
}
